import type { TOC } from '@ember/component/template-only'
import RouteTemplate from 'ember-route-template'
import type PrintablesSetRoute from 'teacher-ui-client/content-preview/printables-set/route'
import { ResourceCard } from 'teacher-ui-client/components/printables/resource-card'
import { t } from 'ember-intl'

interface Signature {
  Args: {
    model: ModelFor<PrintablesSetRoute>
  }
}
export const ContentPreviewPrintablesSetPage: TOC<Signature> = <template>
  <div class="m-12 flex">
    <div class="w-1/3">
      <h5 class="bg-juicy-orange-50 mt-4 mb-6 p-4 text-center">{{t "contentPreview.locales.enAU"}}</h5>
      <ResourceCard @bookSet={{@model.bookSet.au}} />
    </div>
    <div class="w-1/3">
      <h5 class="bg-juicy-orange-100 mt-4 mb-6 p-4 text-center">{{t "contentPreview.locales.enUK"}}</h5>
      <ResourceCard @bookSet={{@model.bookSet.uk}} />
    </div>
    <div class="w-1/3">
      <h5 class="bg-juicy-orange-200 mt-4 mb-6 p-4 text-center">{{t "contentPreview.locales.enUS"}}</h5>
      <ResourceCard @bookSet={{@model.bookSet.us}} />
    </div>
  </div>
</template>

export default RouteTemplate(ContentPreviewPrintablesSetPage)
